import { render, staticRenderFns } from "./Ibox.vue?vue&type=template&id=2dbff023&scoped=true&"
import script from "./Ibox.vue?vue&type=script&lang=js&"
export * from "./Ibox.vue?vue&type=script&lang=js&"
import style0 from "./Ibox.vue?vue&type=style&index=0&id=2dbff023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbff023",
  null
  
)

export default component.exports